export default {"src":"/_next/static/media/empty-state-filings.48d9fd78.svg","height":94,"width":91,"blurWidth":0,"blurHeight":0};